<template>
    <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div class="search-div"  v-if="offModel">
    
                <DatePicker class="input-div" type="datetimerange" @on-change='selectT' format="yyyy-MM-dd HH:mm" :placeholder="$t('selectPlaceholder')" style="width: 300px"></DatePicker>
                <Button type="info" @click="searchItem"  icon="ios-search" style="width:96px;border-radius: 6px;">{{$t('search')}}</Button>
            </div>
    
            <div v-if="offModel">
                <div class="top" v-if='roleType==1'>
                    <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("accountRecharge.addButton")}}</Button>
                </div>

                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>
            <!-- 编辑 / 添加  模态框组件 -->
            <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment';
import ModelBox from './component/rechargeAddModel.vue';
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
            ModelBox
        },
        data(){
            return{
                loading: true,
                offModel: true,
                type:1,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                tableList:{
                    tableData:[],
                    hasSelectData:{}
                },
                searchObj:{
                    startTime:'',
                    endTime:'',
                }
               
            }
        },
        computed:{
           ...mapState(['local','selectId']),
           roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
            titleName(){
                return [
                    {
                        title:this.$t('accountRecharge.titleName.id'),
                        'title-zh-CN':'交易编号',
                        'title-en-US':'Id',
                        key: 'id',
                        minWidth: 100,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('accountRecharge.titleName.transTime'),
                        'title-zh-CN':'交易时间',
                        'title-en-US':'Transaction time',
                        key: 'transTime',
                        minWidth: 180,
                        render:(h, params)=>{
                            // let stext = moment(params.row.transTime*1+8*60*60*1000).format('YYYY-MM-DD HH:mm:ss')
                            let stext = moment(params.row.transTime*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('accountRecharge.titleName.transAmount'),
                        'title-zh-CN':'交易金额',
                        'title-en-US':'Transaction amount',
                        key: 'transAmount',
                        minWidth: 180
                        
                    },
                   {
                        title:this.$t('accountRecharge.titleName.type'),
                        'title-zh-CN':'交易类型',
                        'title-en-US':'Transaction type',
                        key: 'type',
                        minWidth: 160,
                        render:(h, params)=>{
                             let stext = this.$t('selectList.transactionType.Recharge')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('accountRecharge.titleName.remark'),
                        'title-zh-CN':'备注',
                        'title-en-US':'Remark',
                        key: 'remark',
                        minWidth: 240
                    }
                ]
            },
               
        },
        created (){
            this.getData()
        },

        methods: {
            addData(type) {  //添加或编辑数据
                if(this.roleType==2) return
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
              
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    // this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            selectT(val){
               this.searchObj.startTime = val[0]?new Date(val[0]).getTime():""
               this.searchObj.endTime = val[1]?new Date(val[1]).getTime():""
            },
            searchItem(){
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 15
                this.getData()
            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId,
                        type:1,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.translogList,getData.params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data.transList
                    //处理数组
                    if(resData){
                        this.tableList.tableData = resData  //渲染数据
                        this.page.total = result.data.data.meta.count
                        this.loading = false
                    }else{
                        return false
                    }
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>



